import ECO_CHALLENGE_STATUS from "@/common/enums/ecoChallengeStatus";

/**
 * Return string of cs-CZ status format.
 *
 * @param {String} status Status string to be formatted
 * @returns {String}
 */
export function formatStatusToReadable(status) {
  switch (status) {
    case ECO_CHALLENGE_STATUS.DISCARD:
      return 'Zrušeno';
    case ECO_CHALLENGE_STATUS.COLLECTED:
      return 'Zpracovává se';
    case ECO_CHALLENGE_STATUS.WAIT_FOR_RETURN:
      return 'Čeká se na balík';
    case ECO_CHALLENGE_STATUS.WAIT_FOR_COLLECT:
      return 'Dopravuje se';
    case ECO_CHALLENGE_STATUS.GENESIS_CREDITS_ADDED:
      return 'Kredity připsány';
    case ECO_CHALLENGE_STATUS.GENESIS_PROCESSING_ORDER:
      return 'Čeká se na vyřízení objednávky';
    case ECO_CHALLENGE_STATUS.GENESIS_SENDING_TO_THIRD_PARTIES_API:
      return 'Chyba';
    default:
      return "Neznámý stav";
  }
}
